import { render } from "./hazardratiocoif.vue?vue&type=template&id=6b2f2322"
import script from "./hazardratiocoif.vue?vue&type=script&lang=js"
export * from "./hazardratiocoif.vue?vue&type=script&lang=js"

import "./hazardratiocoif.vue?vue&type=style&index=0&id=6b2f2322&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__